import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { TaxReturnsResolver } from "../../../tax-returns-resolver";
import {RubixDocumentsService} from "../rubix-documents.service";
import {Subscription} from "rxjs";
import { ITaxReturn } from '../../model/i-tax-return';
import { ClientNotificationService } from '../../../../client-notification.service';
declare const $: any;

@Component({
    selector: 'app-folder-view',
    templateUrl: './folder-view.component.html',
    styleUrls: ['./folder-view.component.scss'],
    standalone: false
})
export class FolderViewComponent implements OnInit, OnDestroy {

  @ViewChild('newFolderModal') addTaxpayerModalEl: ElementRef;

  layout: 'list' | 'grid' = 'list';
  sortBy: 'type' | 'update';
  sortOrder: 'asc' | 'desc';
  newFolderName = "";
  loading = true;
  isDownloadPending = false;
  taxReturn: ITaxReturn;
  showSelectAll: boolean = true;
  showSortBy: boolean = true;
  showLayout: boolean = true;
  showNewFolder: boolean = true;
  showUploadDocument: boolean = true;
  fileStoreType: 'rubixDocuments'|'configExports' = "rubixDocuments";
  subscriptions: Subscription[] = [];

  constructor(
    public rubixDocumentsService: RubixDocumentsService,
    public clientNotificationService: ClientNotificationService,
    private taxReturnsResolver: TaxReturnsResolver,
  ) { }

  ngOnInit() {
    this.sortOrder = this.rubixDocumentsService.sortOrder;
    this.sortBy = this.rubixDocumentsService.sortBy;
    this.subscriptions.push(
      this.rubixDocumentsService.notifyFolderViewChange$.subscribe(() => {
          this.sortOrder = this.rubixDocumentsService.sortOrder;
          this.sortBy = this.rubixDocumentsService.sortBy;
          this.showSelectAll = this.rubixDocumentsService.propertyVisibility.selectAll;
          this.showSortBy = this.rubixDocumentsService.propertyVisibility.sortBy;
          this.showLayout = this.rubixDocumentsService.propertyVisibility.layout;
          this.showNewFolder = this.rubixDocumentsService.propertyVisibility.newFolder;
          this.showUploadDocument = this.rubixDocumentsService.propertyVisibility.uploadDocument;
          this.fileStoreType = this.rubixDocumentsService.fileStoreType;
        })
    );
    this.subscriptions.push(
      this.rubixDocumentsService.notifyNavigationChange$.subscribe(() => {
        this.loading = this.rubixDocumentsService.loading;
        this.fileStoreType = this.rubixDocumentsService.fileStoreType;
      })
    );
    this.subscriptions.push(this.taxReturnsResolver.getTaxReturnObs().subscribe((data: ITaxReturn) => {
      this.taxReturn = cloneDeep(data);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  changeSortBy(sortBy: 'type' | 'update') {
    this.rubixDocumentsService.changeSortBy(sortBy);
  }

  changeSortOrder(sortOrder: 'asc' | 'desc') {
    this.rubixDocumentsService.changeSortOrder(sortOrder);
  }

  changeLayout(layout: 'list' | 'grid') {
    this.layout = layout;
  }

  changeSelectAll() {
    this.rubixDocumentsService.toggleSelectAllChildren();
  }

  isChildrenAllSelected() {
    return this.rubixDocumentsService.isAllChildrenSelected();
  }

  isDownloadDisabled() {
    return this.isDownloadPending || !this.rubixDocumentsService.hasAnyChildSelected();
  }

  private makeDownloadFilename(folderName: string) {
    if(this.fileStoreType === "configExports"){
      return `${folderName}-configs.zip`;
    } else {
      const taxReturnInfo = `${this.taxReturn.lastName}, ${this.taxReturn.firstName} (${this.taxReturn.atlasId})`;
      return `${taxReturnInfo} - ${folderName}.zip`;
    }
  }

  downloadSelected() {
    this.isDownloadPending = true;
    const fileNameHint = this.makeDownloadFilename(this.rubixDocumentsService.currentFolderDetails.folderMetaData.name);
    this.rubixDocumentsService.downloadSelected(fileNameHint).subscribe(
      (res) => {
        const { fileContent, fileName } = res;
        this.isDownloadPending = false;
        if (!fileContent)  {
          this.clientNotificationService.appendMessage("Download Selected", "Files could not be downloaded, please try again later", false);
          return;
        }
        var elem = window.document.createElement('a');
        elem.href = `data:application/octet-stream;base64,${fileContent}`;
        elem.download = fileName;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }, (error) => {
        this.isDownloadPending = false;
        this.clientNotificationService.appendMessage("Download Selected", "Files could not be downloaded, please try again later", false);
        return;
      });
  }

  openCreateFolderModal() {
    this.newFolderName = "";
    const el = $(this.addTaxpayerModalEl.nativeElement);
    el.modal("show");
  }

  saveNewFolder() {
    this.rubixDocumentsService.createFolder(this.newFolderName);
    $(this.addTaxpayerModalEl.nativeElement).modal('toggle');
  }

  initFile(files: any) {
    const sourceFile = files[0];
    const pattern = (/\.(pdf|docx|xlsx|png|jpg|jpeg|heic|txt|zip)$/i);
    const isValidType = pattern.test(sourceFile.name);
    if (!isValidType) {
      this.clientNotificationService.appendMessage("Upload Document", `File "${sourceFile.name}" is not allowed. Please upload a different file format.` , false);
      return;
    } else {
      this.rubixDocumentsService.uploadFile(sourceFile);
    }
  }
}
